<template>
  <h4><slot /></h4>
</template>
<style scoped>
h4 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 0.5rem;
  line-height: 1.4;
}
</style>
